// 生成亮色和暗夜模式的一对值
export function mode (token1: string, token2: string) {
  return {
    default: token1,
    _dark: token2,
  }
}
